module.exports = __webpack_public_path__ + "static/media/Asset 52.55f36fce.jpg";